import React from "react";
import useDataFetcher from "../../../../common-deprecated/hooks/useDataFetcher";
import type { GetFetchesFnType } from "../../../../common-deprecated/utils/registryTypes";
import { COMPONENT_USED_STOCK_CARS } from "../../../../shared-logic/server/components";
import useUscInsuranceInit from "../../hooks/useUscInsuranceInit";
import useUscFinanceInit from "../../hooks/useUscFinanceInit";
import { useUscSelector } from "../../redux/store";
import NotificationContainer from "../../../../common-deprecated/components/notification/lexus/NotificationContainer";
import { getUscComponentFetches, uscFetchDispatcher } from "../../datafetch/fetchUtils";
import uscPostFetch from "../../datafetch/postFetch";
import { UscNavStepEnum } from "../../utils/constants";
import PdpContainer from "./pdp/PdpContainer";
import ExtrasContainer from "./extras/ExtrasContainer";
import MobileFooter from "./common/MobileFooter";
import useUsedStockCars from "../../hooks/useUsedStockCars";
import useUscExternalPriceInit from "../../hooks/useUscExternalPriceInit";
import useUscCarDeliveryInit from "../../hooks/useUscCarDeliveryInit";
import GlobalStyle from "../../../shared-components/lexus/styles/Global.styles";
import PageDisclaimers from "./common/PageDisclaimers";

const UsedStockCars = (): JSX.Element => {
    const step = useUscSelector((state) => state.nav.step);

    useDataFetcher(
        getUscComponentFetches as unknown as GetFetchesFnType,
        uscFetchDispatcher,
        COMPONENT_USED_STOCK_CARS,
        [],
        ["uscEnv", "brand"],
        uscPostFetch,
    );

    useUsedStockCars();
    // init price integrations
    useUscInsuranceInit();
    useUscFinanceInit();
    useUscExternalPriceInit(step === UscNavStepEnum.Pdp);
    useUscCarDeliveryInit(step === UscNavStepEnum.Extras);

    return (
        // This ID is used in Global.styles to scope global overrides in the Toyota CSS
        <>
            <GlobalStyle />
            {step === UscNavStepEnum.Pdp ? <PdpContainer /> : <ExtrasContainer />}
            <PageDisclaimers />
            <MobileFooter />
            <NotificationContainer />
        </>
    );
};

export default UsedStockCars;
